<template>
  <section>
    <!--工具条-->
    <toolbar
      placeholder="请输入标题"
      :buttonList="buttonList"
      @callFunction="callFunction"
    ></toolbar>

    <!--列表-->
    <el-table
      :data="banners"
      v-loading="listLoading"
      highlight-current-row
      style="width: 100%"
      ref="table"
      @select="dialogCheck"
      @row-click="selectCurrentRow"
      class="custom-tbl"
    >
      <el-table-column type="selection" min-width="30"> </el-table-column>
      <el-table-column type="index" label="序号" min-width="30"> </el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        min-width="250"
      ></el-table-column>
      <el-table-column prop="coverImage" label="图片" min-width="300">
        <template slot-scope="scope">
          <img
            v-if="scope.row.coverImage"
            :src="scope.row.coverImage.url"
            style="width: 160px; height: 90px"
          />
        </template>
      </el-table-column>
      <el-table-column prop="destinationUrl" label="关联跳转" min-width="300">
        <template slot-scope="scope">
          <a target="_blank" :href="scope.row.destinationUrl">{{
            scope.row.destinationUrl
          }}</a>
        </template>
      </el-table-column>
      <el-table-column
        prop="sortNum"
        label="排序"
        width="100"
        sortable
      ></el-table-column>
      <el-table-column label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="small" @click="handleSortPlus(scope.row, 1)"
            >升序</el-button
          >
          <el-button size="small" @click="handleSortPlus(scope.row, -1)"
            >降序</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageModel.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageModel.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageModel.dataCount"
        style="float:right;"
      >
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="100px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="标题" prop="title">
              <el-input v-model="editForm.title" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="展示顺序" prop="sortNum">
              <el-input v-model="editForm.sortNum" type="number"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="关联跳转" prop="destinationUrl">
              <el-input
                v-model="editForm.destinationUrl"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="图片上传" prop="coverImage">
          <ImageFile
            tips="推荐尺寸16:9,大小不超过1MB"
            :value="coverImageList"
            :limitCount="1"
            :limitSize="1024"
            @change="coverImageChange"
          ></ImageFile>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="100px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="标题" prop="title">
              <el-input v-model="addForm.title" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="展示顺序" prop="sortNum">
              <el-input v-model="addForm.sortNum" type="number"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="关联跳转" prop="destinationUrl">
              <el-input
                v-model="addForm.destinationUrl"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="图片上传" prop="coverImage">
          <ImageFile
            tips="推荐尺寸16:9,大小不超过1MB"
            :value="coverImageList"
            :limitCount="1"
            :limitSize="1024"
            @change="coverImageChange"
          ></ImageFile>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import { queryBannerListPage, removeBanner, saveBanner } from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import ImageFile from "../../components/ImageFile";

export default {
  components: { Toolbar, ImageFile },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filter: {
        key: "",
      },
      banners: [],
      pageModel: {
        pageSize: 10,
        dataCount: 0,
        page: 1,
        pageCount: 0,
      },
      listLoading: false,
      sels: [], //列表选中列
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        sortNum: [
          { required: true, message: "请输入展示顺序", trigger: "blur" },
        ],
      },
      //编辑界面数据
      editForm: {
        id: "",
        title: "",
        destinationUrl: "",
        sortNum: 0,
        coverImage: "",
      },
      addFormVisible: false,
      addLoading: false,
      addFormRules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        sortNum: [
          { required: true, message: "请输入展示顺序", trigger: "blur" },
        ],
      },
      //新增界面数据
      addForm: {
        title: "",
        destinationUrl: "",
        sortNum: 0,
        coverImage: "",
      },
      coverImageList: [],
    };
  },
  methods: {
    coverImageChange() {},
    handleSizeChange(val) {
      this.filter.page = 1;
      this.filter.pageSize = val;
      this.handleQuery();
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.handleQuery();
    },
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.filter.key = item.search;
      this[item.func].apply(this, item);
    },
    formatEnabled: function (row, column) {
      return row.enabled ? "正常" : "停用";
    },
    formatStartTime: function (row, column) {
      return row.StartTime | ("" + row.EndTime) | "";
    },
    //获取用户列表
    handleQuery() {
      this.listLoading = true;

      //NProgress.start();
      queryBannerListPage(this.filter).then((res) => {
        this.pageModel = res.data.response;
        this.banners = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    handleSortPlus(row, plusNum) {
      this.listLoading = true;
      row.sortNum = row.sortNum + plusNum;
      let formData = new FormData();
      formData.append("model", JSON.stringify(row));
      saveBanner(formData).then((res) => {
        if (res.data.isSuccess) {
          this.listLoading = false;
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.handleQuery();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeBanner(para).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            if (res.data.isSuccess) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      this.coverImageList = [];
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      if (row.coverImage) {
        this.coverImageList.push(row.coverImage);
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        title: "",
        destinationUrl: "",
        sortNum: 0,
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let formData = new FormData();
            formData.append("model", JSON.stringify(this.editForm));
            let covers = this.coverImageList.filter((s) => s.status == "ready");
            if (covers.length > 0) {
              formData.append("coverImage", covers[0].raw);
            }
            saveBanner(formData).then((res) => {
              if (res.data.isSuccess) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let formData = new FormData();
            formData.append("model", JSON.stringify(this.addForm));
            let covers = this.coverImageList.filter((s) => s.status == "ready");
            if (covers.length > 0) {
              formData.append("coverImage", covers[0].raw);
            }
            saveBanner(formData).then((res) => {
              if (res.data.isSuccess) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
  },
  mounted() {
    this.handleQuery();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
